import { useState } from 'react';
import { IconButton, Box } from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';

const Copyable = ({ value, children, size = 'small', sx = {} }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ...sx,
      }}>
      {children}
      <IconButton
        onClick={handleCopy}
        size={size}
        title={copied ? 'Copied!' : `Copy ${value}`}>
        {copied ? (
          <Check sx={{ fontSize: '14px' }} />
        ) : (
          <ContentCopy sx={{ fontSize: '14px' }} />
        )}
      </IconButton>
    </Box>
  );
};

export default Copyable;
